export type TitleState = string;

const titleReducer = (
  state: TitleState = 'France Challenges',
  action: { type: string } = { type: '' }
) => {
  switch (action.type) {
    case 'HOME_PAGE':
      return 'Bienvenue sur votre dashboard';
    case 'PRODUCTS_PAGE':
      return `Découvrez tous nos produits`;
    case 'COURS_PAGE':
      return 'Consultez tous les cours';
    case 'COURS_SYNTH_PAGE':
      return 'Synthèse de cours';
    case 'ARTICLE_PAGE':
      return `Ceci est un article`;
    default:
      return state;
  }
};
export default titleReducer;
